import { Box, Card, CardContent, Grid2, Typography } from '@mui/material';
import * as Yup from "yup";
import { resumenMutuoModel } from '../models/resumenMutuoModel';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormSetValue } from 'react-hook-form';
import { UseLiquidacion } from '../hooks/useLiquidacion';

import InputText from '../../../components/inputs/yup/materialui/inputText';
import InputFecha from '../../../components/inputs/yup/materialui/inputFecha';
import InputNumber from '../../../components/inputs/yup/materialui/inputNumber';
import InputRut from '../../../components/inputs/yup/materialui/inputRut';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const schema = Yup.object<resumenMutuoModel>().shape({
    mutuoId: Yup.number().optional(),
    numeroOperacion: Yup.string().optional(),
    rut: Yup.string().optional(),
    nombreCliente: Yup.string().optional(),
    telefono: Yup.string().optional(),
    direccion: Yup.string().optional(),
    ciudad: Yup.string().optional(),
    comuna: Yup.string().optional(),
    tipoProducto: Yup.string().optional(),
    objetivoMutuo: Yup.string().optional(),
    montoOriginal: Yup.number().optional(),
    saldoInsoluto: Yup.number().optional(),
    numDividendos: Yup.number().optional(),
    numDivPagados: Yup.number().optional(),
    numDivNoPagados: Yup.number().optional(),
    postergacionDiv: Yup.string().optional(),
    fechaPrimeraFirma: Yup.date().nullable().optional(),
    fechaEndoso: Yup.date().nullable().optional(),
    fechaActivacion: Yup.date().nullable().optional(),
    tasa: Yup.number().optional(),
    plazo: Yup.number().optional(),
    rutDuenoGarantia: Yup.string().optional(),
    nombreDuenoGarantia: Yup.string().optional(),
    numeroSerie: Yup.string().optional(),
    fechaProtocolizacion: Yup.date().nullable().optional(),
    numeroProtocolizacion: Yup.number().optional(),
    numeroRepertorio: Yup.string().optional(),
});

const ResumenMutuo: React.FC = () => {

    const { defaultValues, getResumenLiquidacion } = UseLiquidacion();

    const location = useLocation();
    const { id: idEmergente } = location.state || {}

    const {
        control,
        reset,
        watch
    } = useForm<resumenMutuoModel>({
        defaultValues: defaultValues,
        resolver: yupResolver(schema),
        mode: 'onChange',
    })

    const watcher = watch();

    useEffect(() => {
        getResumenLiquidacion(idEmergente);
    }, [idEmergente])

    useEffect(() => {
        reset(defaultValues);
    }, [defaultValues])

    
    return (
        <Grid2 container padding={2}>
            <form>
                <Grid2 container alignItems="center" spacing={2}>
                    <Grid2 size={2}>
                        <Typography className='card-title' variant="h6">Resumen Mutuo</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={2} mt={2}>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Nro operación"
                            name="numeroOperacion"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputRut
                            label="Rut"
                            name="rut"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Nombre"
                            name="nombreCliente"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Teléfono"
                            name="telefono"
                            readonly
                            control={control}
                            prefix='+569'
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 6 }}>
                        <InputText
                            label="Dirección"
                            name="direccion"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Ciudad"
                            name="ciudad"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Comuna"
                            name="comuna"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Tipo producto"
                            name="tipoProducto"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Objetivo del mutuo"
                            name="objetivoMutuo"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Monto original"
                            name="montoOriginal"
                            readonly
                            control={control}
                            prefix='UF'
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Saldo insoluto"
                            name="saldoInsoluto"
                            readonly
                            control={control}
                            prefix='UF'
                            decimales={4}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Nro dividendos"
                            name="numDividendos"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Nro dividendos pagados"
                            name="numDivPagados"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Nro dividendos impagos"
                            name="numDivNoPagados"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Cobranza Judicial"
                            name="cobranzaJudicial"
                            readonly
                            control={control}
                            color={watcher.cobranzaJudicial?.toLowerCase() !== 'no' ? '#f44336' : ''}
                            isInputBold={watcher.cobranzaJudicial?.toLowerCase() !== 'no'}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Postergación dividendos"
                            name="postergacionDiv"
                            readonly
                            control={control}
                            color={watcher.postergacionDiv?.toLowerCase() !== 'no' ? '#f44336' : ''}
                            isInputBold={watcher.postergacionDiv?.toLowerCase() !== 'no'}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputFecha
                            label="Fecha de primera firma"
                            name="fechaPrimeraFirma"
                            esReadOnly={true}
                            control={control}
                            fecha={defaultValues.fechaPrimeraFirma}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputFecha
                            label="Fecha de endoso"
                            name="fechaEndoso"
                            esReadOnly={true}
                            control={control}
                            fecha={defaultValues.fechaEndoso}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputFecha
                            label="Fecha de activación"
                            name="fechaActivacion"
                            esReadOnly={true}
                            control={control}
                            fecha={defaultValues.fechaActivacion}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Tasa"
                            name="tasa"
                            readonly
                            control={control}
                            suffix='%'
                            decimales={2}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Plazo"
                            name="plazo"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputRut
                            label="Rut dueño garantía"
                            name="rutDuenoGarantia"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Nombre dueño garantía"
                            name="nombreDuenoGarantia"
                            readonly
                            control={control}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 container alignItems="center" spacing={2}>
                    <Grid2 size={2}>
                        <Typography className='card-title' variant="h6">Tabla Desarrollo</Typography>
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={2} mt={2}>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Nro serie"
                            name="numeroSerie"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputFecha
                            label="Fecha protocolización"
                            name="fechaProtocolizacion"
                            esReadOnly={true}
                            control={control}
                            fecha={defaultValues.fechaProtocolizacion}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Nro protocolización"
                            name="numeroProtocolizacion"
                            readonly
                            control={control}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Nro repertorio"
                            name="numeroRepertorio"
                            readonly
                            control={control}
                        />
                    </Grid2>
                </Grid2>
            </form>
        </Grid2>
    )
}   

export default ResumenMutuo;